import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const purposeType = [
    {
        ID: 'S',
        Text: 'Stock',
    },
    {
        ID: 'O',
        Text: 'OM Order',
    },
    {
        ID: 'U',
        Text: 'CA/GL/FA - Usage',
    },
    {
        ID: 'M',
        Text: 'EF - Maintenance Request',
    },
    {
        ID: 'E',
        Text: 'Inventory/Non-Inventery Usage by Equipment',
    },
]
const inventoryType = [
    {
        ID: 'I',
        Text: 'Inventory'
    }
]
const OpenPosTabResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "f7a00789-4b05-4a78-b748-de535b9b9f5b";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="purpose" caption='Purpose'
                    lookup={{ dataSource: purposeType, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'S':
                                return <span>Stock</span>;
                            case 'O':
                                return <span>OM Order</span>;
                            case 'U':
                                return <span>CA/GL/FA - Usage</span>;
                            case 'M':
                                return <span>EF - Maintenance Request</span>;
                            case 'E':
                                return <span>Inventory/Non-Inventery Usage by Equipment</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}></Column>
                <Column dataField="vendorID" caption='Vendor' ></Column>
                <Column dataField="referenceNumber" caption='PO Number' ></Column>
                <Column dataField="lotCode" caption='Lot' ></Column>
                <Column dataField="orderedQuantity" caption='Ordered' dataType="number"
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }} ></Column>
                <Column dataField="unitCostOriginal" caption='Unit Cost' dataType="number"
                    format={{
                        type: 'currency',
                        precision: 2,
                        currency: 'USD',
                        useGrouping: true
                    }}
                ></Column>
                <Column dataField="amount" caption='Amount' dataType="number"
                    format={{
                        type: 'currency',
                        precision: 2,
                        currency: 'USD',
                        useGrouping: true
                    }}  ></Column>
                <Column dataField="poDate" caption='Po Date' dataType="date" ></Column>
                <Column dataField="requiredQuantity" caption='Required' ></Column>
                <Column dataField="detailDateExpected" dataType="date" caption='Expected' ></Column>
                <Column dataField="description" caption='PO Desc' ></Column>
                <Column dataField="taxableflag" caption="Taxable Flag" visible={false}></Column>
                <Column dataField="expirationdate" caption="Expiration Date" dataType="date" visible={false}></Column>
                <Column dataField="daterequired" caption="Date Required" dataType="date" visible={false}></Column>
                <Column dataField="dateexpected" caption="Date Expected" dataType="date" visible={false}></Column>
                <Column dataField="datereceived" caption="Date Received" dataType="date" visible={false}></Column>
                <Column dataField="unitofmeasure" caption="Unit of Measure" visible={false}></Column>
                <Column dataField="unitcostoriginal" caption="Unit Cost Original" visible={false}></Column>
                <Column dataField="unitcostbackorder" caption="Unit Cost Backorder" visible={false}></Column>
                <Column dataField="itemdiscount" caption="Item Discount" visible={false}></Column>
                <Column dataField="detailflag" caption="Detail Flag" visible={false}></Column>
                <Column dataField="comment" caption="Comment" visible={false}></Column>
                <Column dataField="detailmessage" caption="Detail Message" visible={false}></Column>
                <Column dataField="referencenumber" caption="Reference Number" visible={false}></Column>
                <Column dataField="requisitionflag" caption="Requisition Flag" visible={false}></Column>


                <Column dataField="type" caption="Type" visible={false}
                    lookup={{ dataSource: inventoryType, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'I':
                                return <span>Inventory</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}
                ></Column>
                <Column dataField="vendorName" caption="Vendor Name" visible={false}></Column>
                <Column dataField="account" caption="Account" visible={false}></Column>
                <Column dataField="accountDesc" caption="Account Desc" visible={false}></Column>
                <Column dataField="activity" caption="Activity" visible={false}></Column>
                <Column dataField="activityDesc" caption="Activity Desc" visible={false}></Column>
                <Column dataField="terms" caption="Terms" visible={false}></Column>

                <Column dataField="priceLevelA" caption='Price Level A' dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }} ></Column>
                <Column dataField="priceLevelB" caption='Price Level B' dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }} ></Column>
                <Column dataField="priceLevelC" caption='Price Level C' dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }} ></Column>
                <Column dataField="priceLevelD" caption='Price Level D' dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }} ></Column>
                <Column dataField="priceLevelE" caption='Price Level E' dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }} ></Column>

                <Column dataField="orderedquantity" caption="Ordered Quantity" visible={false}></Column>
                <Column dataField="requiredquantity" caption="Required Quantity" visible={false}></Column>
                <Column dataField="backorderquantity" caption="Backorder Quantity" visible={false}></Column>
                <Column dataField="receivedquantity" caption="Received Quantity" visible={false}></Column>
                <Column dataField="userdefinedcomment" caption="User Defined Comment" visible={false}></Column>
                <Column dataField="itempriorityflag" caption="Item Priority Flag" visible={false}></Column>

                <Column dataField="sourcetablename" caption="Source Table Name" visible={false}></Column>
                <Column dataField="orderdate" caption="Order Date" visible={false}></Column>
                <Column dataField="reference" caption="Reference" visible={false}></Column>
                <Column dataField="purposecomment" caption="Purpose Comment" visible={false}></Column>
                <Column dataField="foreignunitcost" caption="Foreign Unit Cost" visible={false}></Column>
                <Column dataField="foreignamount" caption="Foreign Amount" visible={false}></Column>
                <Column dataField="requiredquantityoriginal" caption="Required Quantity Original" visible={false}></Column>
                <Column dataField="unitoriginalcost" caption="Unit Original Cost" visible={false}></Column>
                <Column dataField="originalpocost" caption="Original PO Cost" visible={false}></Column>
                <Column dataField="originalpoquantity" caption="Original PO Quantity" visible={false}></Column>
                <Column dataField="feetype" caption="Fee Type" visible={false}></Column>
                <Column dataField="componentcostdiscount" caption="Component Cost Discount" visible={false}></Column>

                <Column dataField="code1_Detail" caption="Code1 - Detail" visible={false}></Column>
                <Column dataField="code2_Detail" caption="Code2 - Detail" visible={false}></Column>
                <Column dataField="code3_Detail" caption="Code3 - Detail" visible={false}></Column>
                <Column dataField="code4_Detail" caption="Code4 - Detail" visible={false}></Column>
                <Column dataField="code5_Detail" caption="Code5 - Detail" visible={false}></Column>
                <Column dataField="code6_Detail" caption="Code6 - Detail" visible={false}></Column>
                <Column dataField="code7_Detail" caption="Code7 - Detail" visible={false}></Column>
                <Column dataField="code8_Detail" caption="Code8 - Detail" visible={false}></Column>
                <Column dataField="code9_Detail" caption="Code9 - Detail" visible={false}></Column>
                <Column dataField="code10_Detail" caption="Code10 - Detail" visible={false}></Column>

                <Column dataField="code1_Header" caption="Code1 - PO Header" visible={false}></Column>
                <Column dataField="code2_Header" caption="Code2 - PO Header" visible={false}></Column>
                <Column dataField="code3_Header" caption="Code3 - PO Header" visible={false}></Column>
                <Column dataField="code4_Header" caption="Code4 - PO Header" visible={false}></Column>
                <Column dataField="code5_Header" caption="Code5 - PO Header" visible={false}></Column>
                <Column dataField="code6_Header" caption="Code6 - PO Header" visible={false}></Column>
                <Column dataField="code7_Header" caption="Code7 - PO Header" visible={false}></Column>
                <Column dataField="code8_Header" caption="Code8 - PO Header" visible={false}></Column>
                <Column dataField="code9_Header" caption="Code9 - PO Header" visible={false}></Column>
                <Column dataField="code10_Header" caption="Code10 - PO Header" visible={false}></Column>

                <Column dataField="date1_Detail" caption="Date1 _ Detail" dataType="date" visible={false}></Column>
                <Column dataField="date2_Detail" caption="Date2 _ Detail" dataType="date" visible={false}></Column>
                <Column dataField="date3_Detail" caption="Date3 _ Detail" dataType="date" visible={false}></Column>
                <Column dataField="date4_Detail" caption="Date4 _ Detail" dataType="date" visible={false}></Column>
                <Column dataField="date5_Detail" caption="Date5 _ Detail" dataType="date" visible={false}></Column>
                <Column dataField="date6_Detail" caption="Date6 _ Detail" dataType="date" visible={false}></Column>
                <Column dataField="date7_Detail" caption="Date7 _ Detail" dataType="date" visible={false}></Column>
                <Column dataField="date8_Detail" caption="Date8 _ Detail" dataType="date" visible={false}></Column>
                <Column dataField="date9_Detail" caption="Date9 _ Detail" dataType="date" visible={false}></Column>
                <Column dataField="date10_Detail" caption="Date10 _ Detail" dataType="date" visible={false}></Column>

                <Column dataField="date1_Header" caption="Date1 _ PO Header" dataType="date" visible={false}></Column>
                <Column dataField="date2_Header" caption="Date2 _ PO Header" dataType="date" visible={false}></Column>
                <Column dataField="date3_Header" caption="Date3 _ PO Header" dataType="date" visible={false}></Column>
                <Column dataField="date4_Header" caption="Date4 _ PO Header" dataType="date" visible={false}></Column>
                <Column dataField="date5_Header" caption="Date5 _ PO Header" dataType="date" visible={false}></Column>
                <Column dataField="date6_Header" caption="Date6 _ PO Header" dataType="date" visible={false}></Column>
                <Column dataField="date7_Header" caption="Date7 _ PO Header" dataType="date" visible={false}></Column>
                <Column dataField="date8_Header" caption="Date8 _ PO Header" dataType="date" visible={false}></Column>
                <Column dataField="date9_Header" caption="Date9 _ PO Header" dataType="date" visible={false}></Column>
                <Column dataField="date10_Header" caption="Date10 _ PO Header" dataType="date" visible={false}></Column>

                <Column dataField="quantity1_Detail" caption="Quantity1 _ Detail" visible={false}></Column>
                <Column dataField="quantity2_Detail" caption="Quantity2 _ Detail" visible={false}></Column>
                <Column dataField="quantity3_Detail" caption="Quantity3 _ Detail" visible={false}></Column>
                <Column dataField="quantity4_Detail" caption="Quantity4 _ Detail" visible={false}></Column>
                <Column dataField="quantity5_Detail" caption="Quantity5 _ Detail" visible={false}></Column>
                <Column dataField="quantity6_Detail" caption="Quantity6 _ Detail" visible={false}></Column>
                <Column dataField="quantity7_Detail" caption="Quantity7 _ Detail" visible={false}></Column>
                <Column dataField="quantity8_Detail" caption="Quantity8 _ Detail" visible={false}></Column>
                <Column dataField="quantity9_Detail" caption="Quantity9 _ Detail" visible={false}></Column>
                <Column dataField="quantity10_Detail" caption="Quantity10 _ Detail" visible={false}></Column>

                <Column dataField="quantity1_Header" caption="Quantity1 _ PO Header" visible={false}></Column>
                <Column dataField="quantity2_Header" caption="Quantity2 _ PO Header" visible={false}></Column>
                <Column dataField="quantity3_Header" caption="Quantity3 _ PO Header" visible={false}></Column>
                <Column dataField="quantity4_Header" caption="Quantity4 _ PO Header" visible={false}></Column>
                <Column dataField="quantity5_Header" caption="Quantity5 _ PO Header" visible={false}></Column>
                <Column dataField="quantity6_Header" caption="Quantity6 _ PO Header" visible={false}></Column>
                <Column dataField="quantity7_Header" caption="Quantity7 _ PO Header" visible={false}></Column>
                <Column dataField="quantity8_Header" caption="Quantity8 _ PO Header" visible={false}></Column>
                <Column dataField="quantity9_Header" caption="Quantity9 _ PO Header" visible={false}></Column>
                <Column dataField="quantity10_Header" caption="Quantity10 _ PO Header" visible={false}></Column>

                <Column dataField="reference1_Detail" caption="Reference1 _ Detail" visible={false}></Column>
                <Column dataField="reference2_Detail" caption="Reference2 _ Detail" visible={false}></Column>
                <Column dataField="reference3_Detail" caption="Reference3 _ Detail" visible={false}></Column>
                <Column dataField="reference4_Detail" caption="Reference4 _ Detail" visible={false}></Column>
                <Column dataField="reference5_Detail" caption="Reference5 _ Detail" visible={false}></Column>
                <Column dataField="reference6_Detail" caption="Reference6 _ Detail" visible={false}></Column>
                <Column dataField="reference7_Detail" caption="Reference7 _ Detail" visible={false}></Column>
                <Column dataField="reference8_Detail" caption="Reference8 _ Detail" visible={false}></Column>
                <Column dataField="reference9_Detail" caption="Reference9 _ Detail" visible={false}></Column>
                <Column dataField="reference10_Detail" caption="Reference10 _ Detai" visible={false}></Column>

                <Column dataField="reference1_Header" caption="Reference1 _ PO Header" visible={false}></Column>
                <Column dataField="reference2_Header" caption="Reference2 _ PO Header" visible={false}></Column>
                <Column dataField="reference3_Header" caption="Reference3 _ PO Header" visible={false}></Column>
                <Column dataField="reference4_Header" caption="Reference4 _ PO Header" visible={false}></Column>
                <Column dataField="reference5_Header" caption="Reference5 _ PO Header" visible={false}></Column>
                <Column dataField="reference6_Header" caption="Reference6 _ PO Header" visible={false}></Column>
                <Column dataField="reference7_Header" caption="Reference7 _ PO Header" visible={false}></Column>
                <Column dataField="reference8_Header" caption="Reference8 _ PO Header" visible={false}></Column>
                <Column dataField="reference9_Header" caption="Reference9 _ PO Header" visible={false}></Column>
                <Column dataField="reference10_Header" caption="Reference10 _ PO Header" visible={false}></Column>

                <Column dataField="freightrateperitem" caption="Freight Rate per Item" visible={false}></Column>
                <Column dataField="handlingchargeperitem" caption="Handling Charge per Item" visible={false}></Column>
                <Column dataField="taggingchargeperitem" caption="Tagging Charge per Item" visible={false}></Column>
                <Column dataField="inventoryreview" caption="Inventory Review" visible={false}></Column>
                <Column dataField="effectivefreight" caption="Effective Freight" visible={false}></Column>
                <Column dataField="reviewedshippedquantity" caption="Reviewed Shipped Quantity" visible={false}></Column>
                <Column dataField="confirmedshippedquantity" caption="Confirmed Shipped Quantity" visible={false}></Column>
                <Column dataField="reviewstage" caption="Review Stage" visible={false}></Column>
                <Column dataField="reviewbackorderflag" caption="Review Backorder Flag" visible={false}></Column>
                <Column dataField="reviewbackorderreason" caption="Review Backorder Reason" visible={false}></Column>
                <Column dataField="confirmbackorderflag" caption="Confirm Backorder Flag" visible={false}></Column>
                <Column dataField="confirmbackorderreason" caption="Confirm Backorder Reason" visible={false}></Column>
                <Column dataField="unitpricechange" caption="Unit Price Change" visible={false}></Column>
                <Column dataField="freightrateperitemchange" caption="Freight Rate per Item Change" visible={false}></Column>
                <Column dataField="handlingchargeperitemchange" caption="Handling Charge per Item Change" visible={false}></Column>
                <Column dataField="excessquantity" caption="Excess Quantity" visible={false}></Column>


                <Toolbar>
                <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(OpenPosTabResult);